require('es6-promise').polyfill();
require('fetch-ie8');
require('pixi-sound');
require("../scripts/lib/GoogleAnalytics.js");

var StyleSheet = require("../styles/styles.less");
var GameModule = require("exports?Roodik!Game");
var game = new GameModule.Game.Main(document.getElementById('GamePlace'), StyleSheet);



//////////////////
// WEBPACK FOOTER
// ./src/scripts/RoodikGame.js
// module id = 0
// module chunks = 0